import { Pipe, PipeTransform } from '@angular/core';
import { WebStorage } from '../../components/auth/storage/web.storage';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'utcToLocalTime'
})
export class UtcToLocalTimePipe implements PipeTransform {

  constructor(private storage: WebStorage) {
    const userdata = this.storage.getUserData();
    this.setTimeZone(userdata.schoolObj?.timeZone);
  }
  
  private timeZone: string = 'UTC';
  
  setTimeZone(timeZone: string) {
    if (timeZone) {
      this.timeZone = timeZone;  
    }
  }

  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }

    try {
      // Create a moment object from the UTC string
      // Explicitly specify that the input is in UTC
      let date;
      
      // Handle time-only strings (like "14:30:00")
      if (value.includes(':') && !value.includes('T') && !value.includes('-')) {
        // If it's just a time string (HH:mm:ss), create a full datetime in UTC
        const today = moment.utc().format('YYYY-MM-DD');
        date = moment.utc(`${today}T${value}Z`);
      } else {
        // For full datetime strings
        date = moment.utc(value);
      }
      
      // Check if the date is valid
      if (!date.isValid()) {
        return value;
      }
      
      // Convert to the specified timezone
      const localTime = date.tz(this.timeZone);
      
      // Format in 12-hour time with AM/PM
      return localTime.format('h:mm a');
    } catch (error) {
      console.error('Error parsing date:', error, 'Value:', value);
      return value;
    }
  }
}
